module.exports = __webpack_public_path__ + "img/logo_balai_pustaka.46c9f5ed.png";